import gql from 'graphql-tag';

const cardElementConfigurationDetails = gql`
  fragment cardElementConfigurationDetails on ICardElementConfiguration {
    ... on ICardElementConfiguration {
      id
      card_element {
        id
        type
      }
      border {
        type
        width
        color
        opacity
      }
      corner_radius
      help_placeholder
      is_editable
      is_printable
    }

    ... on CardPhotoElementConfiguration {
      background_color
      asset_image {
        id
        url
        width
        height
      }
      photo {
        id
        thumbnail_urls(ignore_watermark: true) {
          size_code
          width
          height
          url
        }
        is_entitled_matched_photo
        faces(slice: { limit: 999 }, exclude_human_labeled_pub_boxes: true) {
          records {
            id
            facebox
          }
        }
      }
      cropbox {
        x
        y
        scale
        rotation
      }
    }

    ... on CardRectangleElementConfiguration {
      color
      opacity
    }

    ... on CardStickerElementConfiguration {
      system_sticker {
        id
        asset_image {
          id
          url
        }
        is_active
      }
    }

    ... on CardTextElementConfiguration {
      text
      font_family
      font_size
      font_color
      text_align
      font_weight
      font_style
      text_transform
    }

    ... on CardAddressElementConfiguration {
      use_family_name
      external_shipping_addresses(slice: { limit: 9999 }) {
        total
        records {
          id
          name
          address_line_1
          address_line_2
          city
          post_code
          state
          country {
            id
            name
            iso
            iso3
          }
        }
      }
      roster_identity_linked_identity_addresses(slice: { limit: 9999 }) {
        total
        records {
          id
          name
          address_line_1
          address_line_2
          city
          post_code
          state
          country {
            id
            name
            iso
            iso3
          }
        }
      }
    }
  }
`;

export default cardElementConfigurationDetails;
